/* tslint:disable */
/* eslint-disable */
/**
 * Tumelo API
 * This is Tumelo\'s API. It drives increased shareholder engagement by providing transparency of the organizations owned by investors and giving them a voice by allowing them to vote on important issues at these organizations.  The main uses of this API are:  * Transparency - To provide a breakdown to an investor of the organizations in which they are invested. * Voting - To provide the ability for an investor to vote on a poll concerning organizations in which they are invested.  ## Status  This API is currently available as a closed **BETA**. We invite interested parties to [give us feedback](mailto:support@tumelo.com) on this API, its documentation, or anything else about Tumelo\'s transparency service prior to the API becoming generally available.  ## Changelog  A changelog for the api can be found [here](CHANGELOG.md).  ## Access The API is available at the following URL: ``` https://api.prod.tumelo.com/v1 ```  For information on how to obtain access to the API, please [contact us](mailto:support@tumelo.com).  ## Development vs Production Habitats Development and Production environments are separated into their own habitats. Please [contact us](mailto:support@tumelo.com) when you\'re ready to go into production and require access to your company\'s live habitat.  # Using the API  ## Case Sensitivity URLs, headers, path parameters, query parameter names, and query parameter values are all case sensitive. Be careful to use the correct case when constructing requests.  ## Error Handling Requests may return an error indicating that there was a problem responding. The response will contain an HTTP status code as well as a JSON object in the following format which describes the error in more detail: ```json {   \"message\": \"Resource not found\" } ```  ## Pagination Requests that return lists and describe pagination parameters support paginated results. Results are separated into multiple pages, where the size of each page is determined by the `pageSize` query parameter. If omitted, `pageSize` defaults to 50 records. When a response includes a `nextPageToken` in the response body, this token value should be passed as a query parameter `nextPageToken` to the same endpoint in order to retrieve the next page of results. This process should be repeated until the response doesn’t include a `nextPageToken`, indicating that the end of the results has been reached.  When passing the `nextPageToken` parameter, all other filter and query parameters present in the previous request, **must** be filled. Filter parameters *must not* be changed while paginating since this will result in an error or an incorrect overall list. The `nextPageToken` will not be present in the response body if the end of the list has been reached and no further results are available.  ## String Formats The following string formats are used throughout this API.  ### date-time The valid format is date-time notation as defined by [RFC 3339, section 5.6](https://tools.ietf.org/html/rfc3339#section-5.6).  For example: `2020-11-30T10:45:28Z`  # Support If you have any technical questions relating to the Tumelo API, please [contact us](mailto:support@tumelo.com), explaining your question or issue in as much detail as possible, including the operation you were performing and the ISIN or Organization ID you were querying, as well as the results you expected and the actual results or error message you observed. You can expect a response within one business day.  ## Data Issues During development and testing in your development habitat we make available a test data set that includes some sample data constructed to illustrate functionality. It is not intended to be used for any purpose other than testing and/or demonstrating functionality, and should not be relied upon to be an accurate reflection of the underlying holdings of any real fund.  If you have any questions or concerns about the data accuracy or completeness of the data in the production environment, please [report the matter](mailto:support@tumelo.com) to us, giving as much information as possible about the issue.  # Compositions and Breakdowns  An instrument may have a composition, this means it is a fund invested in other instruments.  A breakdown is the bottom level components of a composite instrument or account. By this, we mean organizations and cash that a particular composite instrument or account is invested into either directly or through funds.  Breakdowns also have an `other` listing, this is for funds that only have partial information available, or where an instrument is not mapped to an organization. 
 *
 * The version of the OpenAPI document: 0.145.1
 * Contact: support@tumelo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountTag,
  Breakdown,
  InvestorAccount,
  InvestorAccountComposition,
  InvestorAccountComposition2,
  ListAccountTagsResponse,
  ListInvestorAccountCompositionsResponse,
  ListInvestorAccountsResponse,
  ListVotingPolicySelectionsResponse,
  OrganizationBreakdown,
  VotingPolicySelection,
} from '../models';
import {
    AccountTagFromJSON,
    AccountTagToJSON,
    BreakdownFromJSON,
    BreakdownToJSON,
    InvestorAccountFromJSON,
    InvestorAccountToJSON,
    InvestorAccountCompositionFromJSON,
    InvestorAccountCompositionToJSON,
    InvestorAccountComposition2FromJSON,
    InvestorAccountComposition2ToJSON,
    ListAccountTagsResponseFromJSON,
    ListAccountTagsResponseToJSON,
    ListInvestorAccountCompositionsResponseFromJSON,
    ListInvestorAccountCompositionsResponseToJSON,
    ListInvestorAccountsResponseFromJSON,
    ListInvestorAccountsResponseToJSON,
    ListVotingPolicySelectionsResponseFromJSON,
    ListVotingPolicySelectionsResponseToJSON,
    OrganizationBreakdownFromJSON,
    OrganizationBreakdownToJSON,
    VotingPolicySelectionFromJSON,
    VotingPolicySelectionToJSON,
} from '../models';

export interface CreateAccountTagRequest {
    habitatId: string;
    accountTag: AccountTag;
}

export interface CreateInvestorAccountRequest {
    habitatId: string;
    investorId: string;
    investorAccount?: InvestorAccount;
}

export interface CreateInvestorAccountCompositionRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
    investorAccountComposition?: InvestorAccountComposition;
}

export interface CreateVotingPolicySelectionRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
    votingPolicySelection?: VotingPolicySelection;
}

export interface DeleteVotingPolicySelectionRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
    votingPolicySelectionId: string;
}

export interface GetInvestorAccountBreakdownGraphRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
}

export interface GetInvestorAccountEquityBreakdownRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
}

export interface GetInvestorAccountOrganizationBreakdownRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
}

export interface ListAccountTagsRequest {
    habitatId: string;
    ids?: Array<string>;
    externalIds?: Array<string>;
    pageSize?: number;
    nextPageToken?: string;
}

export interface ListInvestorAccountCompositionsRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
    pageSize?: number;
    nextPageToken?: string;
}

export interface ListInvestorAccountsRequest {
    habitatId: string;
    investorId: string;
}

export interface ListVotingPolicySelectionsRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
}

export interface UpdateInvestorAccountRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
    investorAccount?: InvestorAccount;
}

export interface UpdateVotingPolicySelectionRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
    votingPolicySelectionId: string;
    votingPolicySelection?: VotingPolicySelection;
}

/**
 * AccountsApi - interface
 * 
 * @export
 * @interface AccountsApiInterface
 */
export interface AccountsApiInterface {
    /**
     * Returns statistics for a habitat 
     * @summary Create an Account Tag
     * @param {string} habitatId The habitat identifier.
     * @param {AccountTag} accountTag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    createAccountTagRaw(requestParameters: CreateAccountTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountTag>>;

    /**
     * Returns statistics for a habitat 
     * Create an Account Tag
     */
    createAccountTag(requestParameters: CreateAccountTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountTag>;

    /**
     * Creates an account for an investor. An error will be returned if an account already exists with the same `externalId` within the habitat.
     * @summary Create investor account
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {InvestorAccount} [investorAccount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    createInvestorAccountRaw(requestParameters: CreateInvestorAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorAccount>>;

    /**
     * Creates an account for an investor. An error will be returned if an account already exists with the same `externalId` within the habitat.
     * Create investor account
     */
    createInvestorAccount(requestParameters: CreateInvestorAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorAccount>;

    /**
     * Creates an account composition to describe its components. A composition is a snapshot of the account makeup at a specified point in time (the value of the `validTime` property).  The composition with the latest validTime is the current composition for the account. A composition at a particular point in time can be overridden by posting another with the same validTime.  This time based approach to the creation of account compositions allows the recording of compositions over time. 
     * @summary Create investor account composition
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The account identifier.
     * @param {InvestorAccountComposition} [investorAccountComposition] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    createInvestorAccountCompositionRaw(requestParameters: CreateInvestorAccountCompositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorAccountComposition2>>;

    /**
     * Creates an account composition to describe its components. A composition is a snapshot of the account makeup at a specified point in time (the value of the `validTime` property).  The composition with the latest validTime is the current composition for the account. A composition at a particular point in time can be overridden by posting another with the same validTime.  This time based approach to the creation of account compositions allows the recording of compositions over time. 
     * Create investor account composition
     */
    createInvestorAccountComposition(requestParameters: CreateInvestorAccountCompositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorAccountComposition2>;

    /**
     * Creates a Voting Policy Selection to associate a Voting Policy with an Account.   The Voting Policy Selection contains an identifier that can be used to retrieve the associated Voting Policy.   Only one Voting Policy Selection can exist per Account; any existing Voting Policy Selection must be deleted prior to the creation of a new Voting Policy Selection. If a Voting Policy Selection is attempted when an existing Voting Policy Selection exists a 400 - Bad Request error will be returned. 
     * @summary Create Voting Policy Selection
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The account identifier.
     * @param {VotingPolicySelection} [votingPolicySelection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    createVotingPolicySelectionRaw(requestParameters: CreateVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VotingPolicySelection>>;

    /**
     * Creates a Voting Policy Selection to associate a Voting Policy with an Account.   The Voting Policy Selection contains an identifier that can be used to retrieve the associated Voting Policy.   Only one Voting Policy Selection can exist per Account; any existing Voting Policy Selection must be deleted prior to the creation of a new Voting Policy Selection. If a Voting Policy Selection is attempted when an existing Voting Policy Selection exists a 400 - Bad Request error will be returned. 
     * Create Voting Policy Selection
     */
    createVotingPolicySelection(requestParameters: CreateVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VotingPolicySelection>;

    /**
     * Deletes a Voting Policy Selection.   In the event that the supplied votingPolicySelectionId does not exist a 404 - Not Found error will be returned.  Warning - this action is not reversible. 
     * @summary Delete Voting Policy Selection
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The account identifier.
     * @param {string} votingPolicySelectionId The Voting Policy Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    deleteVotingPolicySelectionRaw(requestParameters: DeleteVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes a Voting Policy Selection.   In the event that the supplied votingPolicySelectionId does not exist a 404 - Not Found error will be returned.  Warning - this action is not reversible. 
     * Delete Voting Policy Selection
     */
    deleteVotingPolicySelection(requestParameters: DeleteVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Returns the breakdown of the investor account in terms of the organizations, non-composite instruments, funds, and model portfolios that make up the latest composition.  The endpoint will return a `400 Bad Request` error when the breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * @summary Get breakdown for an investor account
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The investor account identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    getInvestorAccountBreakdownGraphRaw(requestParameters: GetInvestorAccountBreakdownGraphRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Breakdown>>;

    /**
     * Returns the breakdown of the investor account in terms of the organizations, non-composite instruments, funds, and model portfolios that make up the latest composition.  The endpoint will return a `400 Bad Request` error when the breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * Get breakdown for an investor account
     */
    getInvestorAccountBreakdownGraph(requestParameters: GetInvestorAccountBreakdownGraphRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Breakdown>;

    /**
     * Returns the breakdown of the investor account in terms of the organizations that issued the underlying shares.  The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the organization breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * @summary Get equity breakdown for an investor account that only includes instruments with a MIFIR code of \"SHRS\"
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The account identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    getInvestorAccountEquityBreakdownRaw(requestParameters: GetInvestorAccountEquityBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationBreakdown>>;

    /**
     * Returns the breakdown of the investor account in terms of the organizations that issued the underlying shares.  The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the organization breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * Get equity breakdown for an investor account that only includes instruments with a MIFIR code of \"SHRS\"
     */
    getInvestorAccountEquityBreakdown(requestParameters: GetInvestorAccountEquityBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationBreakdown>;

    /**
     * Returns the breakdown of the investor account in terms of the organizations that issued the underlying stocks, shares and bonds.  The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the organization breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * @summary Get organization breakdown for an investor account
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The account identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    getInvestorAccountOrganizationBreakdownRaw(requestParameters: GetInvestorAccountOrganizationBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationBreakdown>>;

    /**
     * Returns the breakdown of the investor account in terms of the organizations that issued the underlying stocks, shares and bonds.  The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the organization breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * Get organization breakdown for an investor account
     */
    getInvestorAccountOrganizationBreakdown(requestParameters: GetInvestorAccountOrganizationBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationBreakdown>;

    /**
     * Returns a list of all the account tags in the habitat.  Additionally a list of either ids or external identifiers can be provided to filter the results.  Either one of these two query parameters can be provided, but not both in the same request: - `ids` - `externalIds`  Requests that include both query parameters return a 400 Bad Request response code.  Here is an example of the format for each query parameter:      /habitats/<habitatId>/accountTag?ids=<value1>,<value2>      /habitats/<habitatId>/accountTags?externalIds=<value1>,<value2>  The request returns only accounts tags for which a match can be found.  The response is paginated if there are more account tags to list than the `pageSize`. When passing a nextPageToken, the ids and externalIds query parameters must also be set. 
     * @summary List Account Tags
     * @param {string} habitatId The habitat identifier.
     * @param {Array<string>} [ids] A comma-separated list of Tumelo account tag identifiers.
     * @param {Array<string>} [externalIds] A comma-separated list of external account tag identifiers.
     * @param {number} [pageSize] The maximum number of elements to return.
     * @param {string} [nextPageToken] Passing a nextPageToken will cause the next page of results to be retrieved.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    listAccountTagsRaw(requestParameters: ListAccountTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAccountTagsResponse>>;

    /**
     * Returns a list of all the account tags in the habitat.  Additionally a list of either ids or external identifiers can be provided to filter the results.  Either one of these two query parameters can be provided, but not both in the same request: - `ids` - `externalIds`  Requests that include both query parameters return a 400 Bad Request response code.  Here is an example of the format for each query parameter:      /habitats/<habitatId>/accountTag?ids=<value1>,<value2>      /habitats/<habitatId>/accountTags?externalIds=<value1>,<value2>  The request returns only accounts tags for which a match can be found.  The response is paginated if there are more account tags to list than the `pageSize`. When passing a nextPageToken, the ids and externalIds query parameters must also be set. 
     * List Account Tags
     */
    listAccountTags(requestParameters: ListAccountTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAccountTagsResponse>;

    /**
     * List all account compositions in chronological order. The composition with the latest `validAt` time is listed first. For compositions with the same `validAt` times, the one with the latest `createdAt` time is listed first. Without any pagination parameters, a maximum of 50 compositions will be returned.
     * @summary List investor account compositions
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The account identifier.
     * @param {number} [pageSize] The maximum number of elements to return.
     * @param {string} [nextPageToken] Passing a nextPageToken will cause the next page of results to be retrieved.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    listInvestorAccountCompositionsRaw(requestParameters: ListInvestorAccountCompositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvestorAccountCompositionsResponse>>;

    /**
     * List all account compositions in chronological order. The composition with the latest `validAt` time is listed first. For compositions with the same `validAt` times, the one with the latest `createdAt` time is listed first. Without any pagination parameters, a maximum of 50 compositions will be returned.
     * List investor account compositions
     */
    listInvestorAccountCompositions(requestParameters: ListInvestorAccountCompositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvestorAccountCompositionsResponse>;

    /**
     * Returns a list of investor accounts with details of each account.
     * @summary List investor accounts
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    listInvestorAccountsRaw(requestParameters: ListInvestorAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvestorAccountsResponse>>;

    /**
     * Returns a list of investor accounts with details of each account.
     * List investor accounts
     */
    listInvestorAccounts(requestParameters: ListInvestorAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvestorAccountsResponse>;

    /**
     * List all account Voting Policy Selections.
     * @summary List Voting Policy Selections
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The account identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    listVotingPolicySelectionsRaw(requestParameters: ListVotingPolicySelectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListVotingPolicySelectionsResponse>>;

    /**
     * List all account Voting Policy Selections.
     * List Voting Policy Selections
     */
    listVotingPolicySelections(requestParameters: ListVotingPolicySelectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListVotingPolicySelectionsResponse>;

    /**
     * Updates an account for an investor. An error will be returned if an account already exists with the same `externalId` within the habitat. The full account object must be sent, any omitted properties will be cleared. Only modelPortfolioId, title and externalId can be updated. 
     * @summary Update investor account
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The investor account identifier.
     * @param {InvestorAccount} [investorAccount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    updateInvestorAccountRaw(requestParameters: UpdateInvestorAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorAccount>>;

    /**
     * Updates an account for an investor. An error will be returned if an account already exists with the same `externalId` within the habitat. The full account object must be sent, any omitted properties will be cleared. Only modelPortfolioId, title and externalId can be updated. 
     * Update investor account
     */
    updateInvestorAccount(requestParameters: UpdateInvestorAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorAccount>;

    /**
     * Updates a Voting Policy Selection.  Only the automatic voting field can be changed, all other changes will be ignored. 
     * @summary Update a Voting Policy Selection
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The account identifier.
     * @param {string} votingPolicySelectionId The voting policy selection identifier.
     * @param {VotingPolicySelection} [votingPolicySelection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    updateVotingPolicySelectionRaw(requestParameters: UpdateVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VotingPolicySelection>>;

    /**
     * Updates a Voting Policy Selection.  Only the automatic voting field can be changed, all other changes will be ignored. 
     * Update a Voting Policy Selection
     */
    updateVotingPolicySelection(requestParameters: UpdateVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VotingPolicySelection>;

}

/**
 * 
 */
export class AccountsApi extends runtime.BaseAPI implements AccountsApiInterface {

    /**
     * Returns statistics for a habitat 
     * Create an Account Tag
     */
    async createAccountTagRaw(requestParameters: CreateAccountTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountTag>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling createAccountTag.');
        }

        if (requestParameters.accountTag === null || requestParameters.accountTag === undefined) {
            throw new runtime.RequiredError('accountTag','Required parameter requestParameters.accountTag was null or undefined when calling createAccountTag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/accountTags`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccountTagToJSON(requestParameters.accountTag),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountTagFromJSON(jsonValue));
    }

    /**
     * Returns statistics for a habitat 
     * Create an Account Tag
     */
    async createAccountTag(requestParameters: CreateAccountTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountTag> {
        const response = await this.createAccountTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates an account for an investor. An error will be returned if an account already exists with the same `externalId` within the habitat.
     * Create investor account
     */
    async createInvestorAccountRaw(requestParameters: CreateInvestorAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorAccount>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling createInvestorAccount.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling createInvestorAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestorAccountToJSON(requestParameters.investorAccount),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorAccountFromJSON(jsonValue));
    }

    /**
     * Creates an account for an investor. An error will be returned if an account already exists with the same `externalId` within the habitat.
     * Create investor account
     */
    async createInvestorAccount(requestParameters: CreateInvestorAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorAccount> {
        const response = await this.createInvestorAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates an account composition to describe its components. A composition is a snapshot of the account makeup at a specified point in time (the value of the `validTime` property).  The composition with the latest validTime is the current composition for the account. A composition at a particular point in time can be overridden by posting another with the same validTime.  This time based approach to the creation of account compositions allows the recording of compositions over time. 
     * Create investor account composition
     */
    async createInvestorAccountCompositionRaw(requestParameters: CreateInvestorAccountCompositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorAccountComposition2>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling createInvestorAccountComposition.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling createInvestorAccountComposition.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling createInvestorAccountComposition.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}/compositions`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestorAccountCompositionToJSON(requestParameters.investorAccountComposition),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorAccountComposition2FromJSON(jsonValue));
    }

    /**
     * Creates an account composition to describe its components. A composition is a snapshot of the account makeup at a specified point in time (the value of the `validTime` property).  The composition with the latest validTime is the current composition for the account. A composition at a particular point in time can be overridden by posting another with the same validTime.  This time based approach to the creation of account compositions allows the recording of compositions over time. 
     * Create investor account composition
     */
    async createInvestorAccountComposition(requestParameters: CreateInvestorAccountCompositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorAccountComposition2> {
        const response = await this.createInvestorAccountCompositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a Voting Policy Selection to associate a Voting Policy with an Account.   The Voting Policy Selection contains an identifier that can be used to retrieve the associated Voting Policy.   Only one Voting Policy Selection can exist per Account; any existing Voting Policy Selection must be deleted prior to the creation of a new Voting Policy Selection. If a Voting Policy Selection is attempted when an existing Voting Policy Selection exists a 400 - Bad Request error will be returned. 
     * Create Voting Policy Selection
     */
    async createVotingPolicySelectionRaw(requestParameters: CreateVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VotingPolicySelection>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling createVotingPolicySelection.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling createVotingPolicySelection.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling createVotingPolicySelection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}/votingPolicySelections`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VotingPolicySelectionToJSON(requestParameters.votingPolicySelection),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VotingPolicySelectionFromJSON(jsonValue));
    }

    /**
     * Creates a Voting Policy Selection to associate a Voting Policy with an Account.   The Voting Policy Selection contains an identifier that can be used to retrieve the associated Voting Policy.   Only one Voting Policy Selection can exist per Account; any existing Voting Policy Selection must be deleted prior to the creation of a new Voting Policy Selection. If a Voting Policy Selection is attempted when an existing Voting Policy Selection exists a 400 - Bad Request error will be returned. 
     * Create Voting Policy Selection
     */
    async createVotingPolicySelection(requestParameters: CreateVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VotingPolicySelection> {
        const response = await this.createVotingPolicySelectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a Voting Policy Selection.   In the event that the supplied votingPolicySelectionId does not exist a 404 - Not Found error will be returned.  Warning - this action is not reversible. 
     * Delete Voting Policy Selection
     */
    async deleteVotingPolicySelectionRaw(requestParameters: DeleteVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling deleteVotingPolicySelection.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling deleteVotingPolicySelection.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling deleteVotingPolicySelection.');
        }

        if (requestParameters.votingPolicySelectionId === null || requestParameters.votingPolicySelectionId === undefined) {
            throw new runtime.RequiredError('votingPolicySelectionId','Required parameter requestParameters.votingPolicySelectionId was null or undefined when calling deleteVotingPolicySelection.');
        }

        const queryParameters: any = {};

        if (requestParameters.votingPolicySelectionId !== undefined) {
            queryParameters['votingPolicySelectionId'] = requestParameters.votingPolicySelectionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}/votingPolicySelections`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a Voting Policy Selection.   In the event that the supplied votingPolicySelectionId does not exist a 404 - Not Found error will be returned.  Warning - this action is not reversible. 
     * Delete Voting Policy Selection
     */
    async deleteVotingPolicySelection(requestParameters: DeleteVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteVotingPolicySelectionRaw(requestParameters, initOverrides);
    }

    /**
     * Returns the breakdown of the investor account in terms of the organizations, non-composite instruments, funds, and model portfolios that make up the latest composition.  The endpoint will return a `400 Bad Request` error when the breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * Get breakdown for an investor account
     */
    async getInvestorAccountBreakdownGraphRaw(requestParameters: GetInvestorAccountBreakdownGraphRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Breakdown>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getInvestorAccountBreakdownGraph.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling getInvestorAccountBreakdownGraph.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling getInvestorAccountBreakdownGraph.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}/breakdownGraph`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BreakdownFromJSON(jsonValue));
    }

    /**
     * Returns the breakdown of the investor account in terms of the organizations, non-composite instruments, funds, and model portfolios that make up the latest composition.  The endpoint will return a `400 Bad Request` error when the breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * Get breakdown for an investor account
     */
    async getInvestorAccountBreakdownGraph(requestParameters: GetInvestorAccountBreakdownGraphRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Breakdown> {
        const response = await this.getInvestorAccountBreakdownGraphRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the breakdown of the investor account in terms of the organizations that issued the underlying shares.  The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the organization breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * Get equity breakdown for an investor account that only includes instruments with a MIFIR code of \"SHRS\"
     */
    async getInvestorAccountEquityBreakdownRaw(requestParameters: GetInvestorAccountEquityBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationBreakdown>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getInvestorAccountEquityBreakdown.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling getInvestorAccountEquityBreakdown.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling getInvestorAccountEquityBreakdown.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}/equityBreakdown`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationBreakdownFromJSON(jsonValue));
    }

    /**
     * Returns the breakdown of the investor account in terms of the organizations that issued the underlying shares.  The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the organization breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * Get equity breakdown for an investor account that only includes instruments with a MIFIR code of \"SHRS\"
     */
    async getInvestorAccountEquityBreakdown(requestParameters: GetInvestorAccountEquityBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationBreakdown> {
        const response = await this.getInvestorAccountEquityBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the breakdown of the investor account in terms of the organizations that issued the underlying stocks, shares and bonds.  The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the organization breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * Get organization breakdown for an investor account
     */
    async getInvestorAccountOrganizationBreakdownRaw(requestParameters: GetInvestorAccountOrganizationBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationBreakdown>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getInvestorAccountOrganizationBreakdown.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling getInvestorAccountOrganizationBreakdown.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling getInvestorAccountOrganizationBreakdown.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}/organizationBreakdown`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationBreakdownFromJSON(jsonValue));
    }

    /**
     * Returns the breakdown of the investor account in terms of the organizations that issued the underlying stocks, shares and bonds.  The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the organization breakdown cannot be computed due to either the account containing no composition or the latest composition being empty. 
     * Get organization breakdown for an investor account
     */
    async getInvestorAccountOrganizationBreakdown(requestParameters: GetInvestorAccountOrganizationBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationBreakdown> {
        const response = await this.getInvestorAccountOrganizationBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of all the account tags in the habitat.  Additionally a list of either ids or external identifiers can be provided to filter the results.  Either one of these two query parameters can be provided, but not both in the same request: - `ids` - `externalIds`  Requests that include both query parameters return a 400 Bad Request response code.  Here is an example of the format for each query parameter:      /habitats/<habitatId>/accountTag?ids=<value1>,<value2>      /habitats/<habitatId>/accountTags?externalIds=<value1>,<value2>  The request returns only accounts tags for which a match can be found.  The response is paginated if there are more account tags to list than the `pageSize`. When passing a nextPageToken, the ids and externalIds query parameters must also be set. 
     * List Account Tags
     */
    async listAccountTagsRaw(requestParameters: ListAccountTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAccountTagsResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling listAccountTags.');
        }

        const queryParameters: any = {};

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.externalIds) {
            queryParameters['externalIds'] = requestParameters.externalIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/accountTags`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAccountTagsResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of all the account tags in the habitat.  Additionally a list of either ids or external identifiers can be provided to filter the results.  Either one of these two query parameters can be provided, but not both in the same request: - `ids` - `externalIds`  Requests that include both query parameters return a 400 Bad Request response code.  Here is an example of the format for each query parameter:      /habitats/<habitatId>/accountTag?ids=<value1>,<value2>      /habitats/<habitatId>/accountTags?externalIds=<value1>,<value2>  The request returns only accounts tags for which a match can be found.  The response is paginated if there are more account tags to list than the `pageSize`. When passing a nextPageToken, the ids and externalIds query parameters must also be set. 
     * List Account Tags
     */
    async listAccountTags(requestParameters: ListAccountTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAccountTagsResponse> {
        const response = await this.listAccountTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all account compositions in chronological order. The composition with the latest `validAt` time is listed first. For compositions with the same `validAt` times, the one with the latest `createdAt` time is listed first. Without any pagination parameters, a maximum of 50 compositions will be returned.
     * List investor account compositions
     */
    async listInvestorAccountCompositionsRaw(requestParameters: ListInvestorAccountCompositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvestorAccountCompositionsResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling listInvestorAccountCompositions.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling listInvestorAccountCompositions.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling listInvestorAccountCompositions.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}/compositions`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInvestorAccountCompositionsResponseFromJSON(jsonValue));
    }

    /**
     * List all account compositions in chronological order. The composition with the latest `validAt` time is listed first. For compositions with the same `validAt` times, the one with the latest `createdAt` time is listed first. Without any pagination parameters, a maximum of 50 compositions will be returned.
     * List investor account compositions
     */
    async listInvestorAccountCompositions(requestParameters: ListInvestorAccountCompositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvestorAccountCompositionsResponse> {
        const response = await this.listInvestorAccountCompositionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of investor accounts with details of each account.
     * List investor accounts
     */
    async listInvestorAccountsRaw(requestParameters: ListInvestorAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvestorAccountsResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling listInvestorAccounts.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling listInvestorAccounts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInvestorAccountsResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of investor accounts with details of each account.
     * List investor accounts
     */
    async listInvestorAccounts(requestParameters: ListInvestorAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvestorAccountsResponse> {
        const response = await this.listInvestorAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all account Voting Policy Selections.
     * List Voting Policy Selections
     */
    async listVotingPolicySelectionsRaw(requestParameters: ListVotingPolicySelectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListVotingPolicySelectionsResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling listVotingPolicySelections.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling listVotingPolicySelections.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling listVotingPolicySelections.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}/votingPolicySelections`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListVotingPolicySelectionsResponseFromJSON(jsonValue));
    }

    /**
     * List all account Voting Policy Selections.
     * List Voting Policy Selections
     */
    async listVotingPolicySelections(requestParameters: ListVotingPolicySelectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListVotingPolicySelectionsResponse> {
        const response = await this.listVotingPolicySelectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an account for an investor. An error will be returned if an account already exists with the same `externalId` within the habitat. The full account object must be sent, any omitted properties will be cleared. Only modelPortfolioId, title and externalId can be updated. 
     * Update investor account
     */
    async updateInvestorAccountRaw(requestParameters: UpdateInvestorAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorAccount>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling updateInvestorAccount.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling updateInvestorAccount.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling updateInvestorAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvestorAccountToJSON(requestParameters.investorAccount),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorAccountFromJSON(jsonValue));
    }

    /**
     * Updates an account for an investor. An error will be returned if an account already exists with the same `externalId` within the habitat. The full account object must be sent, any omitted properties will be cleared. Only modelPortfolioId, title and externalId can be updated. 
     * Update investor account
     */
    async updateInvestorAccount(requestParameters: UpdateInvestorAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorAccount> {
        const response = await this.updateInvestorAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a Voting Policy Selection.  Only the automatic voting field can be changed, all other changes will be ignored. 
     * Update a Voting Policy Selection
     */
    async updateVotingPolicySelectionRaw(requestParameters: UpdateVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VotingPolicySelection>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling updateVotingPolicySelection.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling updateVotingPolicySelection.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling updateVotingPolicySelection.');
        }

        if (requestParameters.votingPolicySelectionId === null || requestParameters.votingPolicySelectionId === undefined) {
            throw new runtime.RequiredError('votingPolicySelectionId','Required parameter requestParameters.votingPolicySelectionId was null or undefined when calling updateVotingPolicySelection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}/votingPolicySelections/{votingPolicySelectionId}`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))).replace(`{${"votingPolicySelectionId"}}`, encodeURIComponent(String(requestParameters.votingPolicySelectionId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: VotingPolicySelectionToJSON(requestParameters.votingPolicySelection),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VotingPolicySelectionFromJSON(jsonValue));
    }

    /**
     * Updates a Voting Policy Selection.  Only the automatic voting field can be changed, all other changes will be ignored. 
     * Update a Voting Policy Selection
     */
    async updateVotingPolicySelection(requestParameters: UpdateVotingPolicySelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VotingPolicySelection> {
        const response = await this.updateVotingPolicySelectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
